import { useTranslation } from 'react-i18next';

interface LiveEvent {
  id: number;
  title: string;
  league: string;
  time: string;
  status: 'live' | 'upcoming';
  score?: string;
  category: string;
  viewers: number;
}

const liveEvents: LiveEvent[] = [
  {
    id: 1,
    title: '曼联 vs 曼城',
    league: '英超联赛',
    time: '进行中 - 67\'',
    status: 'live',
    score: '1 : 2',
    category: '足球',
    viewers: 856000,
  },
  {
    id: 2,
    title: '湖人 vs 勇士',
    league: 'NBA常规赛',
    time: '进行中 - Q3 5:42',
    status: 'live',
    score: '78 : 82',
    category: '篮球',
    viewers: 623000,
  },
  {
    id: 3,
    title: 'T1 vs Gen.G',
    league: 'LCK夏季赛',
    time: '进行中 - G2',
    status: 'live',
    score: '1 : 1',
    category: '电竞',
    viewers: 412000,
  },
  {
    id: 4,
    title: '纳达尔 vs 德约科维奇',
    league: 'ATP大师赛',
    time: '即将开始 20:00',
    status: 'upcoming',
    category: '网球',
    viewers: 0,
  },
];

export default function LiveEvents() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            {t('home.live.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('home.live.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {liveEvents.map((event) => (
            <div
              key={event.id}
              className="bg-background-50 rounded-lg border border-background-200/60 p-5 transition-all duration-300 hover:scale-[1.01] cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                  {event.league}
                </span>
                {event.status === 'live' ? (
                  <span className="flex items-center gap-1 text-xs font-semibold text-primary-600">
                    <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                    直播中
                  </span>
                ) : (
                  <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2 py-0.5 rounded">
                    即将开始
                  </span>
                )}
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-3 font-heading">
                {event.title}
              </h3>
              {event.status === 'live' && event.score && (
                <div className="text-2xl font-bold text-primary-600 mb-3 tracking-wider">
                  {event.score}
                </div>
              )}
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span>{event.time}</span>
                {event.viewers > 0 && (
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(event.viewers / 10000).toFixed(1)}万
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}